import { render, staticRenderFns } from "./PrimaryNavigation.vue?vue&type=template&id=5550462e&"
import script from "./PrimaryNavigation.vue?vue&type=script&lang=js&"
export * from "./PrimaryNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports